import {Helmet} from 'react-helmet-async';
import {posts} from '../posts/index.js';

import {Card} from '../components/Card'
import {SimpleLayout} from '../components/SimpleLayout'
import {formatDate} from '../lib/formatDate.js'
import {Container} from "../components/Container.jsx";
import {Header} from "../components/Header.jsx";
import {Footer} from "../components/Footer.jsx";

function Article({article}) {
    return (
        <article className="md:grid md:grid-cols-4 md:items-baseline">
            <Card className="md:col-span-3">
                <Card.Title href={`/articles/${article.slug}`}>
                    {article.title}
                </Card.Title>
                <Card.Eyebrow
                    as="time"
                    dateTime={article.date}
                    className="md:hidden"
                    decorate
                >
                    {formatDate(article.date)}
                </Card.Eyebrow>
                <Card.Description>{article.description}</Card.Description>
                <Card.Cta>Read article</Card.Cta>
            </Card>
            <Card.Eyebrow
                as="time"
                dateTime={article.date}
                className="mt-1 hidden md:block"
            >
                {formatDate(article.date)}
            </Card.Eyebrow>
        </article>
    )
}

export default function ArticlesIndex() {
    let articles = posts

    return (
        <div>
            <Helmet>
                <title>Michael Leitz</title>
                <meta name="description"
                      content="I'm Leitz, a software guy who's done every job in tech. Based in Nashville, TN. I help people understand the tech world by sharing wisdom acquired in my 25 years of professional delopment experience."/>
                <meta property="og:title" content="Leitz - Home"/>
                <meta
                    property="og:description"
                    content="Personal site of Michael Leitz, prolific software developer and manager"
                />
                <meta property="og:image" content="/images/portrait.jpg"/>
                <meta property="og:type" content="website"/>
            </Helmet>
            <Header/>
            <main className="main flex flex-col items-center">
                <Container>
                    <SimpleLayout
                        title="TWO decades in software"
                        intro="Thoughts and experiences from 25 years in the software business."
                    >
                        <div className="md:border-l md:border-zinc-100 md:pl-6 md:dark:border-zinc-700/40">
                            <div className="flex max-w-3xl flex-col space-y-16">
                                {articles.map((article) => (
                                    <Article key={article.slug} article={article}/>
                                ))}
                            </div>
                        </div>
                    </SimpleLayout>
                </Container>
            </main>
            <Footer/>
        </div>
    )
}
